import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import 'style/tailwind.css'
import 'style/mobile.css'
import store from 'js/redux/store'
import { Amplify } from 'aws-amplify'
import { Authenticator, View } from '@aws-amplify/ui-react'
import App from './App'
import { Auth0Provider, Auth0Context } from "@auth0/auth0-react";

Amplify.configure({
  Auth: {
    region: process.env.AWS_REGION,
    userPoolId: process.env.COGNITO_USER_POOL_ID,
    userPoolWebClientId: process.env.COGNITO_CLIENT_ID,
    identityPoolId:  process.env.COGNITO_IDENTITY_POOL_ID
  }
})

const providerConfig = {
  domain: process.env.AUTH0_DOMAIN,
  clientId: process.env.AUTH0_CLIENT_ID,
  authorizationParams:{
    redirect_uri: window.location.origin
  }
};


const MOUNT_NODE = document.getElementById('app')
const render = () => {
  ReactDOM.render(    
    <BrowserRouter>
      <Auth0Provider {...providerConfig} store={store}>
        <Auth0Context.Consumer>
        {({ getAccessTokenSilently }) => {
          return (
            <Provider getAccessTokenSilently store={store}>
              <Authenticator.Provider>
                <View>
                  <App />
                </View>
              </Authenticator.Provider>
            </Provider>
          );
        }}
        </Auth0Context.Consumer>
      </Auth0Provider>
    </BrowserRouter>,
    MOUNT_NODE
  )
}

render()
